// extracted by mini-css-extract-plugin
module.exports = {"box":"_21QqU","showMore":"EFgMA"};